import store from "@/store";
import Axios from "@/config/backend-service";

export async function checkUserExist(to) {
  return new Promise((resolve) => {
    const platform = to.query.platform === undefined ? "" : to.query.platform;
    let path = to.path;
    if (platform) {
      path = to.fullPath;
    }

    let pathName = to.name;
  
    store.commit("login/SET_URL_REDIRECT", { urlRedirect: path });
    if (platform || pathName =='mission-detail') {
      store.commit("friend/SET_PLATFORM", to.query.platform);
      countPlatform(
        to.query.platform ?? 'Website',
        store.state.login.mobile ||
        store.state.defaultSystem?.userLine?.userId ||
        store.state.defaultSystem?.customer?.id ||
        null,
        to.params.id
      );
    }
    resolve(
      store.state.login.mobile ||
      store.state.defaultSystem?.userLine?.userId ||
      store.state.defaultSystem?.customer?.id ||
      null
    );
  });
}

function countPlatform(platform, customer, mission_id) {
  Axios.post("site/countPlatform", {
    platform: platform,
    customer: customer,
    mission_id: mission_id,
  });
}
